import { useCallback, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch } from 'react-redux';
import { setIdleTimer } from '../app/store/majesticSlice';

function useSession() {
  const [timeoutMinutes, setTimeoutMinutes] = useState(30); // Minutos permitido de inactividad
  const [showWarning, setShowWarning] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const dispatch = useDispatch();

  const saveSession = useCallback(
    (expiration) => {
      localStorage.setItem('session', JSON.stringify({ exp: expiration, timeout: timeoutMinutes }));
    },
    [timeoutMinutes],
  );

  const logout = useCallback(() => {
    console.log('logout Session');
    localStorage.removeItem('session');
    setIsActive(false);
    setShowWarning(false);
    dispatch(setIdleTimer({ showModal: true, action: 'INIT' }));
  }, [dispatch]);

  const { reset } = useIdleTimer({
    timeout: timeoutMinutes * 60000,
    onIdle: logout,
    onAction: () => {
      const newExpiration = Date.now() + timeoutMinutes * 60000;
      saveSession(newExpiration);
      reset();
    },
    events: ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'],
    debounce: 500,
    startOnMount: false,
  });

  const startSession = () => {
    console.log('startSession');
    const timeout = timeoutMinutes;
    const expirationTime = Date.now() + timeout * 60000;
    saveSession(expirationTime);
    setIsActive(true);
    reset();
  };

  return {
    isActive,
    showWarning,
    startSession,
    logout,
    timeoutMinutes,
    setTimeoutMinutes,
  };
}

export default useSession;
